import React, {
  memo,
  forwardRef,
  useMemo,
  useImperativeHandle,
  useCallback
} from "../../../__snowpack__/pkg/react.js";
import {Form, Select, Button, Input, DatePicker} from "../../../__snowpack__/pkg/antd.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
import {useIntl} from "../../../__snowpack__/pkg/react-intl.js";
import {debounce} from "../../../__snowpack__/pkg/lodash.js";
const {Option} = Select;
const {RangePicker} = DatePicker;
const SearchForm = forwardRef((props, ref) => {
  const {fields = [], handleSubmit, propForm} = props;
  const {formatMessage} = useIntl();
  const [form] = Form.useForm();
  const formInstance = useMemo(() => {
    if (propForm) {
      return propForm;
    }
    return form;
  }, [propForm, form]);
  useImperativeHandle(ref, () => ({
    getForm: () => formInstance,
    resetFields: (fields2) => formInstance?.resetFields(fields2),
    getFieldValue: (name) => formInstance?.getFieldValue(name),
    getFieldsValue: (nameList) => formInstance?.getFieldsValue(nameList),
    setFields: (fields2) => formInstance?.setFields(fields2),
    validateFields: (nameList) => formInstance?.validateFields(nameList)
  }));
  const getFieldItem = (item) => {
    const {
      label,
      name,
      type,
      rules = [],
      options = [],
      formItemProps,
      render,
      dsiabled,
      componentProps
    } = item;
    if (render && typeof render == "function") {
      return render();
    } else {
      if (type) {
        if (type == "select") {
          return /* @__PURE__ */ React.createElement(Select, {
            style: {width: "120px"},
            ...componentProps
          }, options.map((item2) => {
            return /* @__PURE__ */ React.createElement(Option, {
              key: item2?.value,
              value: item2?.value
            }, item2?.label);
          }));
        }
        if (type == "input") {
          return /* @__PURE__ */ React.createElement(Input, {
            style: {width: "180px"},
            ...componentProps
          });
        }
        if (type == "dataRange") {
          return /* @__PURE__ */ React.createElement(RangePicker, {
            ...componentProps
          });
        }
        return /* @__PURE__ */ React.createElement(React.Fragment, null);
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null);
    }
  };
  const getFields = useMemo(() => {
    return fields.map((item) => {
      const {label, name, rules = [], initialValue, formItemProps} = item;
      return /* @__PURE__ */ React.createElement(Form.Item, {
        key: name,
        name,
        label,
        rules,
        initialValue,
        ...formItemProps
      }, getFieldItem(item));
    });
  }, [fields]);
  const handleSearchSubmit = useCallback(debounce(async () => {
    try {
      const formValues = await formInstance.validateFields();
      if (typeof handleSubmit == "function") {
        handleSubmit(formValues);
      }
    } catch (error) {
      console.log("error", error);
      throw error;
    }
  }, 500), [handleSubmit]);
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className: "searchFormWrapper"
  }, /* @__PURE__ */ React.createElement(Form, {
    className: "searchForm",
    form: formInstance,
    layout: "inline"
  }, getFields), /* @__PURE__ */ React.createElement(Button, {
    onClick: handleSearchSubmit,
    className: "searchConfirm",
    type: "primary"
  }, formatMessage({id: "search"})));
});
export default memo(SearchForm);
const Wrapper = styled.div`
  &.searchFormWrapper {
    flex: 1;
    display: flex;
    /* align-items: center; */
  }
  .searchConfirm {
    margin-left: 20px;
  }
  .searchForm {
  }
`;
